export const matchRoute = (
  pattern: string,
  path: string,
): Readonly<Record<string, string>> | undefined => {
  const patternParts = pattern.split('/').filter((part) => part !== '');
  const pathParts = path.split('/').filter((part) => part !== '');

  if (patternParts.length !== pathParts.length) {
    return undefined;
  }

  const isMatch = patternParts.every(
    (part, index) => part.startsWith(':') || part === pathParts[index],
  );
  if (!isMatch) {
    return undefined;
  }

  return Object.fromEntries(
    patternParts
      .map((part, index) => [part, pathParts[index]] as const)
      .filter(
        (entry): entry is readonly [string, string] =>
          entry[0].startsWith(':') && entry[1] !== undefined,
      )
      .map(([part, value]) => [part.slice(1), decodeURIComponent(value)]),
  );
};
